import { render } from "./GameLog.vue?vue&type=template&id=ac13f5d2&scoped=true"
import script from "./GameLog.vue?vue&type=script&lang=js"
export * from "./GameLog.vue?vue&type=script&lang=js"

import "./GameLog.vue?vue&type=style&index=0&id=ac13f5d2&scoped=true&lang=scss"
import "./GameLog.vue?vue&type=style&index=1&id=ac13f5d2&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac13f5d2"]])

export default __exports__